module.exports = __webpack_public_path__ + "static/media/car-2-toowoomba.02ecfc42.png";